module.exports = __webpack_public_path__ + "img/hs_kyoto.2606276e.png";